var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeedexlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182.461,
    height: 58.756,
    viewBox: "0 0 182.461 58.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.516,
    cy: 0.103,
    r: 1.505,
    gradientTransform: "matrix(0, 1, 1, 0, -1, 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3727FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#8980FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8980FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14899",
    "data-name": "Group 14899",
    transform: "translate(-407.713 -909.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12704",
    "data-name": "Group 12704",
    transform: "translate(407.713 909.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18729",
    "data-name": "Path 18729",
    d: "M139.355,131.611H125.532a.482.482,0,0,0-.481.481v13.822a.482.482,0,0,0,.481.481h13.822a.482.482,0,0,0,.482-.481V132.092a.482.482,0,0,0-.482-.481",
    transform: "translate(-116.057 -109.625)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18730",
    "data-name": "Path 18730",
    d: "M112.026,99.763a.482.482,0,0,0,.672.107l11.182-8.124a.482.482,0,0,0,.107-.673L115.863,79.89a.481.481,0,0,0-.672-.106l-11.182,8.124a.481.481,0,0,0-.107.672Z",
    transform: "translate(-103.81 -79.691)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18731",
    "data-name": "Path 18731",
    d: "M112.7,170.67a.481.481,0,0,0-.672.107L103.9,181.959a.481.481,0,0,0,.107.672l11.182,8.124a.481.481,0,0,0,.672-.107l8.124-11.182a.482.482,0,0,0-.107-.672Z",
    transform: "translate(-103.81 -132.091)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12705",
    "data-name": "Group 12705",
    transform: "translate(454.192 924.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18723",
    "data-name": "Path 18723",
    d: "M221.54,143.573v-23.3a.381.381,0,0,0-.382-.381h-7.037a.55.55,0,0,1-.55-.55v-3.2a.55.55,0,0,1,.55-.55h19.341a.55.55,0,0,1,.551.55v3.2a.55.55,0,0,1-.551.55h-7.037a.381.381,0,0,0-.382.381v23.3a.55.55,0,0,1-.551.55h-3.4a.55.55,0,0,1-.55-.55",
    transform: "translate(-213.571 -115.593)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18724",
    "data-name": "Path 18724",
    d: "M275.186,150.593a.555.555,0,0,1,.217.8,10.692,10.692,0,0,1-3.195,3.251,9.839,9.839,0,0,1-5.579,1.514,10.358,10.358,0,0,1-4.044-.777,9.575,9.575,0,0,1-3.208-2.172,9.971,9.971,0,0,1-2.112-3.287,11.685,11.685,0,0,1-.04-8.169,10.189,10.189,0,0,1,2.012-3.307,9.582,9.582,0,0,1,7.193-3.088,10.216,10.216,0,0,1,4.044.757,8.577,8.577,0,0,1,3.009,2.112,9.249,9.249,0,0,1,1.892,3.268,12.785,12.785,0,0,1,.658,4.184v.358a1.856,1.856,0,0,0-.04.359,1.286,1.286,0,0,0-.04.319h-14.4a.555.555,0,0,0-.545.648,5.79,5.79,0,0,0,.6,1.783,5.7,5.7,0,0,0,1.375,1.713,5.373,5.373,0,0,0,1.813,1,6.367,6.367,0,0,0,1.952.319,5.143,5.143,0,0,0,3.148-.916,7.536,7.536,0,0,0,1.783-1.875.544.544,0,0,1,.693-.176Zm-3.8-7.27a.192.192,0,0,0,.187-.23,6.043,6.043,0,0,0-.34-1.105,4.089,4.089,0,0,0-.916-1.354,5.3,5.3,0,0,0-1.594-1.056,5.766,5.766,0,0,0-2.371-.438,5,5,0,0,0-3.287,1.135,5.512,5.512,0,0,0-1.788,2.807.191.191,0,0,0,.185.241Z",
    transform: "translate(-238.326 -126.986)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18725",
    "data-name": "Path 18725",
    d: "M327.034,150.593a.555.555,0,0,1,.217.8,10.692,10.692,0,0,1-3.195,3.251,9.84,9.84,0,0,1-5.579,1.514,10.358,10.358,0,0,1-4.044-.777,9.574,9.574,0,0,1-3.208-2.172,9.97,9.97,0,0,1-2.112-3.287,11.685,11.685,0,0,1-.04-8.169,10.186,10.186,0,0,1,2.012-3.307,9.581,9.581,0,0,1,7.193-3.088,10.216,10.216,0,0,1,4.044.757,8.578,8.578,0,0,1,3.009,2.112,9.249,9.249,0,0,1,1.892,3.268,12.783,12.783,0,0,1,.658,4.184v.358a1.858,1.858,0,0,0-.04.359,1.288,1.288,0,0,0-.04.319h-14.4a.555.555,0,0,0-.545.648,5.792,5.792,0,0,0,.6,1.783,5.7,5.7,0,0,0,1.375,1.713,5.374,5.374,0,0,0,1.813,1,6.367,6.367,0,0,0,1.952.319,5.143,5.143,0,0,0,3.148-.916,7.535,7.535,0,0,0,1.783-1.875.544.544,0,0,1,.693-.176Zm-3.8-7.27a.192.192,0,0,0,.187-.23,6.017,6.017,0,0,0-.341-1.105,4.079,4.079,0,0,0-.916-1.354,5.3,5.3,0,0,0-1.594-1.056,5.766,5.766,0,0,0-2.371-.438,5,5,0,0,0-3.287,1.135,5.512,5.512,0,0,0-1.788,2.807.191.191,0,0,0,.185.241Z",
    transform: "translate(-268.218 -126.986)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18726",
    "data-name": "Path 18726",
    d: "M376.1,141.612h-.239a6.71,6.71,0,0,1-2.431,2.212,7.73,7.73,0,0,1-3.905.937,8.457,8.457,0,0,1-3.567-.777,9.148,9.148,0,0,1-2.968-2.172,10.689,10.689,0,0,1-2.033-3.287,11.829,11.829,0,0,1,0-8.328,10.7,10.7,0,0,1,2.033-3.287,9.154,9.154,0,0,1,2.968-2.172,8.45,8.45,0,0,1,3.567-.777,7.729,7.729,0,0,1,3.905.937,7.156,7.156,0,0,1,2.742,3.358h.621l-.932-3.842v-8.269a.55.55,0,0,1,.55-.55h3.322a.551.551,0,0,1,.55.55v27.43a.551.551,0,0,1-.55.55h-3.083a.551.551,0,0,1-.551-.55Zm-5.738-.956a5.608,5.608,0,0,0,2.171-.438,5.437,5.437,0,0,0,1.833-1.235,6.043,6.043,0,0,0,1.255-1.972,7.582,7.582,0,0,0,0-5.3,6.058,6.058,0,0,0-1.255-1.973,5.448,5.448,0,0,0-1.833-1.235,5.649,5.649,0,0,0-4.363,0,5.356,5.356,0,0,0-1.813,1.255,6.344,6.344,0,0,0-1.256,1.972,7.48,7.48,0,0,0,0,5.26,6.337,6.337,0,0,0,1.256,1.973,5.344,5.344,0,0,0,1.813,1.255,5.56,5.56,0,0,0,2.192.438",
    transform: "translate(-298.11 -115.592)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18727",
    "data-name": "Path 18727",
    d: "M433.743,150.593a.555.555,0,0,1,.217.8,10.693,10.693,0,0,1-3.195,3.251,9.84,9.84,0,0,1-5.579,1.514,10.358,10.358,0,0,1-4.044-.777,9.573,9.573,0,0,1-3.208-2.172,9.972,9.972,0,0,1-2.112-3.287,11.684,11.684,0,0,1-.04-8.169,10.186,10.186,0,0,1,2.012-3.307,9.581,9.581,0,0,1,7.193-3.088,10.215,10.215,0,0,1,4.044.757,8.578,8.578,0,0,1,3.009,2.112,9.25,9.25,0,0,1,1.892,3.268,12.783,12.783,0,0,1,.658,4.184v.358a1.845,1.845,0,0,0-.04.359,1.285,1.285,0,0,0-.04.319h-14.4a.555.555,0,0,0-.545.648,5.792,5.792,0,0,0,.6,1.783,5.7,5.7,0,0,0,1.375,1.713,5.372,5.372,0,0,0,1.813,1,6.366,6.366,0,0,0,1.952.319,5.143,5.143,0,0,0,3.148-.916,7.536,7.536,0,0,0,1.783-1.875.544.544,0,0,1,.693-.176Zm-3.8-7.27a.192.192,0,0,0,.187-.23,6.047,6.047,0,0,0-.341-1.105,4.086,4.086,0,0,0-.916-1.354,5.3,5.3,0,0,0-1.594-1.056,5.766,5.766,0,0,0-2.371-.438,5,5,0,0,0-3.287,1.135,5.512,5.512,0,0,0-1.788,2.807l.185.241Z",
    transform: "translate(-329.741 -126.986)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18728",
    "data-name": "Path 18728",
    d: "M469.6,146.081l-5.913-8.354a.551.551,0,0,1,.449-.868H467.9a.55.55,0,0,1,.473.269l3.7,6.224h.763l3.508-6.213a.551.551,0,0,1,.479-.28h3.929a.551.551,0,0,1,.443.877l-6.148,8.345,0,.763,6.283,8.666a.551.551,0,0,1-.446.874h-3.964a.383.383,0,0,1-.328-.186l-3.755-6.307h-.763l-3.788,6.309a.382.382,0,0,1-.327.185h-3.95a.55.55,0,0,1-.451-.865l6.046-8.675Z",
    transform: "translate(-357.641 -127.854)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18741",
    "data-name": "Path 18741",
    d: "M1.445-2.894V-6.229H.29V-6.98H3.524v.751H2.384v3.335ZM4-2.894V-6.98H5.069l.91,1.761h.072l.9-1.761H7.957v4.086H7.119V-4.511l.072-1.271H7.134L5.979-3.6,4.824-5.782H4.766l.072,1.271v1.617Z",
    transform: "translate(128.025 15.986)",
    fill: "#161616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeedexlogo);
export default __webpack_public_path__ + "static/media/teedexlogo.3f538ae873035540b0d816d8eccd6388.svg";
export { ForwardRef as ReactComponent };